import { useState, useCallback } from 'react';
import { isGoogleDriveConfigured } from '../config/googleDrive';
import {
  requestAccessToken,
  getAccessToken,
  revokeToken,
} from '../services/googleDriveService';

interface GoogleDriveAuthState {
  isConfigured: boolean;
  isAuthenticated: boolean;
  isAuthenticating: boolean;
  error: string | null;
  authenticate: () => Promise<boolean>;
  signOut: () => void;
}

export function useGoogleDriveAuth(): GoogleDriveAuthState {
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => getAccessToken() !== null
  );
  const [error, setError] = useState<string | null>(null);

  const authenticate = useCallback(async (): Promise<boolean> => {
    setIsAuthenticating(true);
    setError(null);

    const result = await requestAccessToken();

    setIsAuthenticating(false);

    if (result.ok) {
      setIsAuthenticated(true);
      return true;
    }

    setError(result.error);
    return false;
  }, []);

  const signOut = useCallback(() => {
    revokeToken();
    setIsAuthenticated(false);
    setError(null);
  }, []);

  return {
    isConfigured: isGoogleDriveConfigured(),
    isAuthenticated,
    isAuthenticating,
    error,
    authenticate,
    signOut,
  };
}
